<div class="row row-header">
	<div class="col">

		<div class="breadcrumbs">
			<span class="a-link" (click)="returnToPreviousPage()" (keypress)="returnToPreviousPage()">
				<i class="material-icons">arrow_back</i>
				{{ labels().PROFILE_FORM_COMPONENT_PREVIOUS_PAGE }}
			</span>
		</div>

		<h1>{{ labels().PROFILE_FORM_COMPONENT_TITLE }}</h1>

	</div>
</div>

<form [formGroup]="profileForm">

	<div class="row row-contents">

		<div class="col-lg-6">
			<p class="pb-5" [innerHTML]="labels().PROFILE_FORM_COMPONENT_MSG"></p>
		</div>

		<div class="w-100"></div>

		<div class="col-lg-3">
			<div class="form-group">
				<label for="FirstName">{{ labels().PROFILE_FORM_COMPONENT_FIRST_NAME }}</label>
				<small id="FirstName" class="help-text" style="font-size: 1.5rem">{{ profileForm.value.firstName }}</small>
			</div>
		</div>

		<div class="col-lg-3">
			<div class="form-group">
				<label for="LastName">{{ labels().PROFILE_FORM_COMPONENT_LAST_NAME }}</label>
				<small id="LastName" class="help-text" style="font-size: 1.5rem">{{ profileForm.value.lastName }}</small>
			</div>
		</div>

		<div class="w-100"></div>

		<div class="col-lg-3">
			<div class="form-group">
				<label for="Email">{{ labels().PROFILE_FORM_COMPONENT_EMAIL }}</label>
				<small id="Email" class="help-text" style="font-size: 1.5rem">{{ profileForm.value.email }}</small>
			</div>
		</div>

		<div class="col-lg-3">
			<div class="form-group">
				<label for="RoleInfo">{{ labels().PROFILE_FORM_COMPONENT_ROLE_INFO }}</label>
				<small id="RoleInfo" class="help-text" style="font-size: 1.5rem">
					{{ isSurgeon ? labels().PROFILE_FORM_COMPONENT_HCP : profileForm.value.roleInfo }}
				</small>
			</div>
		</div>

		<div class="w-100"></div>

		<div class="col-lg-3">
			<div class="form-group">
				<label for="Country">{{ labels().PROFILE_FORM_COMPONENT_COUNTRY }}</label>
				<small id="Country" class="help-text" style="font-size: 1.5rem">{{ profileForm.value.country?.name }}</small>
			</div>
		</div>

		<div class="col-lg-3">

			<div class="form-group">
				<label for="dateOfBirth">{{ labels().PROFILE_FORM_COMPONENT_DATE_OF_BIRTH }} *
					<span data-testid="SUBSYS2_PROFILE_FORMATDATE_TXT" class="date-format ms-3">{{ dateFormat }}</span>
				</label>
				<div class="input-group wrapper-calendar" #dateOfBirthTarget
					[class]="{'is-valid': profileForm.controls.dateOfBirth.valid && profileForm.controls.dateOfBirth.touched, 'is-invalid': profileForm.controls.dateOfBirth.invalid && profileForm.controls.dateOfBirth.touched }">
					<i class="material-icons input-group-append icon-calendar" (click)="dateOfBirthPicker.toggle()"
						(keypress)="dateOfBirthPicker.toggle()">today</i>
					<input type="text" autocomplete="off" class="form-control" id="dateOfBirth"
						[placeholder]="labels().PROFILE_FORM_COMPONENT_DATE_OF_BIRTH" formControlName="dateOfBirthFormat"
						(focus)="profileForm.controls.dateOfBirth.markAsTouched()"
						[class]="{'is-valid': profileForm.controls.dateOfBirth.valid && profileForm.controls.dateOfBirth.touched, 'is-invalid': profileForm.controls.dateOfBirth.invalid && profileForm.controls.dateOfBirth.touched }"
						readonly style="color: #fff" [appFormValidationMsg]="errorMsgs.dateOfBirth"
						[customControl]="profileForm.controls.dateOfBirth" [container]="dateOfBirthTarget" />
					<i class="material-icons input-group-append align-self-center md-18" (click)="clearDateOfBirth()"
						(keypress)="clearDateOfBirth()">clear</i>
				</div>
			</div>
			<datepicker #dateOfBirthPicker [value]="profileForm.value.dateOfBirth!" (dateChanged)="updateDateOfBirth($event)"
				[positionTarget]="dateOfBirthTarget" placement="bottom-end" [maxDate]="maxDateOfBirth" />
		</div>

		<div class="w-100"></div>

		@if (isSurgeon) {

		<div class="col-lg-3">
			<div class="form-group">
				<label for="Hospital">{{ labels().PROFILE_FORM_COMPONENT_HOSPITAL }} *</label>
				<input type="text" autocomplete="off" class="form-control" id="Hospital"
					[placeholder]="labels().PROFILE_FORM_COMPONENT_HOSPITAL" formControlName="hospital"
					[class]="{'is-valid': profileForm.controls.hospital.valid && profileForm.controls.hospital.touched, 'is-invalid': profileForm.controls.hospital.invalid && profileForm.controls.hospital.touched}"
					[appFormValidationMsg]="errorMsgs.hospital">
			</div>
		</div>

		<div class="col-lg-3">
			<div class="form-group">
				<label for="Distributor">{{ labels().PROFILE_FORM_COMPONENT_DISTRIBUTOR }} *</label>
				<input type="text" autocomplete="off" class="form-control" id="Distributor"
					[placeholder]="labels().PROFILE_FORM_COMPONENT_DISTRIBUTOR" formControlName="distributor"
					[class]="{'is-valid': profileForm.controls.distributor.valid && profileForm.controls.distributor.touched, 'is-invalid': profileForm.controls.distributor.invalid && profileForm.controls.distributor.touched}"
					[appFormValidationMsg]="errorMsgs.distributor">
			</div>
		</div>

		} @else {

		<div class="col-lg-3">
			<div class="form-group">
				<label for="Company">{{ labels().PROFILE_FORM_COMPONENT_COMPANY }} *</label>
				<input type="text" autocomplete="off" class="form-control" id="Company"
					[placeholder]="labels().PROFILE_FORM_COMPONENT_COMPANY" formControlName="company"
					[class]="{'is-valid': profileForm.controls.company.valid && profileForm.controls.company.touched, 'is-invalid': profileForm.controls.company.invalid && profileForm.controls.company.touched}"
					[appFormValidationMsg]="errorMsgs.company">
			</div>
		</div>

		}

		<div class="w-100"></div>

		@if (!isUnitedStates) {

		<div class="col-lg-3">
			<div class="form-group">
				<label for="StateProvince">{{ labels().PROFILE_FORM_COMPONENT_STATE_PROVINCE }} *</label>
				<input type="text" autocomplete="off" class="form-control" id="StateProvince"
					[placeholder]="labels().PROFILE_FORM_COMPONENT_STATE_PROVINCE" formControlName="stateProvince"
					[class]="{'is-valid': profileForm.controls.stateProvince.valid && profileForm.controls.stateProvince.touched, 'is-invalid': profileForm.controls.stateProvince.invalid && profileForm.controls.stateProvince.touched}"
					[appFormValidationMsg]="errorMsgs.stateProvince">
			</div>
		</div>

		} @else {

		<div class="col-lg-3">
			<div class="form-group">
				<label for="USStateProvince">{{ labels().PROFILE_FORM_COMPONENT_STATE_PROVINCE }} *</label>
				<select class="form-control custom-select" id="USStateProvince" autocomplete="off"
					formControlName="usStateProvince"
					[class]="{'is-valid': profileForm.controls.usStateProvince.valid && profileForm.controls.usStateProvince.touched, 'is-invalid': profileForm.controls.usStateProvince.invalid && profileForm.controls.usStateProvince.touched}"
					[appFormValidationMsg]="errorMsgs.usStateProvince">
					<option [ngValue]="null">{{ labels().PROFILE_FORM_COMPONENT_STATE_PROVINCE_SELECT }}</option>
					@for (state of allUsStates; track state) {
					<option [ngValue]="state">{{ state }}</option>
					}
				</select>
			</div>
		</div>

		}

		<div class="col-lg-3">
			<div class="form-group">
				<label for="City">{{ labels().PROFILE_FORM_COMPONENT_CITY }} *</label>
				<input type="text" autocomplete="off" class="form-control" id="City"
					[placeholder]="labels().PROFILE_FORM_COMPONENT_CITY" formControlName="city"
					[class]="{'is-valid': profileForm.controls.city.valid && profileForm.controls.city.touched, 'is-invalid': profileForm.controls.city.invalid && profileForm.controls.city.touched}"
					[appFormValidationMsg]="errorMsgs.city">
			</div>
		</div>

		<div class="w-100"></div>

		<div class="col-lg-3">
			<div class="form-group">
				<label for="Address">{{ labels().PROFILE_FORM_COMPONENT_ADDRESS }} *</label>
				<input type="text" autocomplete="off" class="form-control" id="Address"
					[placeholder]="labels().PROFILE_FORM_COMPONENT_ADDRESS" formControlName="address"
					[class]="{'is-valid': profileForm.controls.address.valid && profileForm.controls.address.touched, 'is-invalid': profileForm.controls.address.invalid && profileForm.controls.address.touched}"
					[appFormValidationMsg]="errorMsgs.address">
			</div>
		</div>

		<div class="col-lg-3">
			<div class="form-group">
				<label for="PostalCode">{{ labels().PROFILE_FORM_COMPONENT_POSTAL_CODE }} *</label>
				<input type="text" autocomplete="off" class="form-control" id="PostalCode"
					[placeholder]="labels().PROFILE_FORM_COMPONENT_POSTAL_CODE" formControlName="postalCode"
					[class]="{'is-valid': profileForm.controls.postalCode.valid && profileForm.controls.postalCode.touched, 'is-invalid': profileForm.controls.postalCode.invalid && profileForm.controls.postalCode.touched}"
					[appFormValidationMsg]="errorMsgs.postalCode">
			</div>
		</div>

		<div class="w-100"></div>

		<div class="col-lg-3">
			<div class="form-group">
				<label for="OfficePhone">{{ labels().PROFILE_FORM_COMPONENT_OFFICE_PHONE }} *</label>
				<input type="text" autocomplete="off" class="form-control" id="OfficePhone"
					[placeholder]="labels().PROFILE_FORM_COMPONENT_OFFICE_PHONE" formControlName="officePhone"
					[class]="{'is-valid': profileForm.controls.officePhone.valid && profileForm.controls.officePhone.touched, 'is-invalid': profileForm.controls.officePhone.invalid && profileForm.controls.officePhone.touched}"
					[appFormValidationMsg]="errorMsgs.officePhone">
			</div>
		</div>

		<div class="col-lg-3">
			<div class="form-group">
				<label for="MobilePhone">{{ labels().PROFILE_FORM_COMPONENT_MOBILE }}</label>
				<input type="text" autocomplete="off" class="form-control" id="MobilePhone"
					[placeholder]="labels().PROFILE_FORM_COMPONENT_MOBILE" formControlName="mobilePhone"
					[class]="{'is-valid': profileForm.controls.mobilePhone.valid && profileForm.controls.mobilePhone.touched, 'is-invalid': profileForm.controls.mobilePhone.invalid && profileForm.controls.mobilePhone.touched}"
					[appFormValidationMsg]="errorMsgs.mobilePhone">
			</div>
		</div>

		<div class="w-100"></div>

		@if (profileForm.value.practice) {

		<div class="col-lg-3">
			<div class="form-group">
				<label for="Practice">{{ labels().PROFILE_FORM_COMPONENT_PRACTICE }}</label>
				<small id="Practice" class="help-text" style="font-size: 1.5rem">{{ profileForm.value.practice.type }}</small>
			</div>
		</div>

		<div class="col-lg-3">
			<div class="form-group">
				<label for="Npi">{{ labels().PROFILE_FORM_COMPONENT_NPI }}</label>
				<small id="Npi" class="help-text" style="font-size: 1.5rem">{{ profileForm.value.practice.npi }}</small>
			</div>
		</div>

		<div class="w-100"></div>

		<div class="col-lg-3">
			<div class="form-group">
				<label for="StateLicences">{{ labels().PROFILE_FORM_COMPONENT_STATE_LICENCES }}</label>
				<small class="help-text" style="font-size: 1.5rem">{{ profileForm.value.practice.l1StateCode }}
					{{profileForm.value.practice.l1Number}}</small><br />
				@if (profileForm.value.practice.l2StateCode) {
				<small class="help-text" style="font-size: 1.5rem">{{ profileForm.value.practice.l2StateCode }} &nbsp;
					{{profileForm.value.practice.l2Number}}</small><br />
				}
				@if (profileForm.value.practice.l3StateCode) {
				<small class="help-text" style="font-size: 1.5rem">{{ profileForm.value.practice.l3StateCode }} &nbsp;
					{{profileForm.value.practice.l3Number}}</small><br />
				}
				@if (profileForm.value.practice.l4StateCode) {
				<small class="help-text" style="font-size: 1.5rem">{{ profileForm.value.practice.l4StateCode }} &nbsp;
					{{profileForm.value.practice.l4Number}}</small><br />
				}
				@if (profileForm.value.practice.l5StateCode) {
				<small class="help-text" style="font-size: 1.5rem">{{ profileForm.value.practice.l5StateCode }} &nbsp;
					{{profileForm.value.practice.l5Number}}</small>
				}
			</div>
		</div>

		<div class="w-100"></div>

		}

		<div class="col-lg-6">
			<button type="button" class="btn btn-primary" [disabled]="!profileForm.valid || isSaving"
				(click)="openConfirmModal()">
				{{ labels().PROFILE_FORM_COMPONENT_SUBMIT_BTN }}
			</button>
		</div>


	</div>

</form>